module.exports = __webpack_public_path__ + "static/media/047.785a33d2.wav";


/*****************
 ** WEBPACK FOOTER
 ** ./src/sound/047.wav
 ** module id = 179
 ** module chunks = 0
 **/